module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_7005.1b08bc31.png";